import styled from '@emotion/styled';
import {md} from '../../variables.styles';

export const ControlBar = styled.div`
  display: flex;
  gap: ${md};
  justify-content: space-between;
`;

export const ControlsContainer = styled.div`
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${md};
  gap: ${md};
  pointer-events: initial;
`;

export const ControlGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${md};
`;
